module.exports = __webpack_public_path__ + "static/media/accounting-bookkeeping.ef162f14.svg";